export default function Automation() {
  return (
    <div className="" data-testid="automation-page">
      <h1 className="text-3xl font-bold text-slate-900 mb-2" style={{fontFamily: 'Outfit'}}>Automation</h1>
      <p className="text-slate-500 mb-8">Configure automation rules and workflows</p>
      
      <div className="bg-white rounded-xl p-12 border border-slate-200 text-center">
        <p className="text-slate-500">Automation tools - Coming in Phase 4</p>
        <p className="text-xs text-slate-400 mt-2">Features: Auto-assignment, notifications, scheduled reports</p>
      </div>
    </div>
  );
}
